import {RouterModule, Routes} from '@angular/router';
import {AplicacionTipoFormComponent} from './form/aplicacion-tipo-form.component';
import {AplicacionTipoListComponent} from './list/aplicacion-tipo-list.component';
import {NgModule} from '@angular/core';

const routes: Routes = [
  {
    path: '',
    component: AplicacionTipoListComponent,
    pathMatch: 'full'
  },
  {
    path: 'registrar',
    component: AplicacionTipoFormComponent,
  },
  {
    path: 'modificar',
    component: AplicacionTipoFormComponent,
  },
  {
    path: 'ver',
    component: AplicacionTipoFormComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AplicacionTipoRoutingModule {
}
